const defaultState = { isBoxTab: false };

export default function(state = defaultState, action) {
  switch (action.type) {
    case 'SET_IS_BOX_TAB':
      return { ...state, isBoxTab: action.payload };
    case 'SET_GLOBALS':
      return { ...state, ...action.payload };
    case 'REST_GLOBALS_TO_DEFAULT':
      return defaultState;
    default:
      return state;
  }
}
